import { InstagramIcon, NewTwitterIcon, TiktokIcon } from "@hugeicons-pro/core-stroke-standard";
import { HugeiconsIcon } from "@hugeicons/react";
import { Link } from "@inertiajs/react";
import { index as tutorialsIndex } from "@/routes/tutorials";

const socialAccounts = [
  {
    label: "حساب أوراق على إنستغرام",
    href: "https://www.instagram.com/awraq.app/",
    icon: InstagramIcon,
  },
  {
    label: "حساب أوراق على إكس",
    href: "https://x.com/AwraqApp",
    icon: NewTwitterIcon,
  },
  {
    label: "حساب أوراق على تيك توك",
    href: "https://www.tiktok.com/@awraq.app",
    icon: TiktokIcon,
  },
] as const;

export default function GuestFooter() {
  return (
    <div className="px-8">
      <div className="flex flex-col items-center justify-center gap-1.5 text-sm underline underline-offset-4">
        <Link href={tutorialsIndex()}>الشروحات</Link>
        <Link href="/refund-policy" target="_blank">
          سياسة الاسترجاع
        </Link>
        <Link href="/privacy-policy" target="_blank">
          سياسة الخصوصية
        </Link>
        <Link href="/account-deletion" target="_blank">
          حذف الحساب
        </Link>
      </div>

      <div className="mt-8 flex flex-col items-center justify-center gap-1 text-sm text-gray-600">
        <div>
          <span>مؤسسة</span>
          <span className="font-bold text-gray-800"> أوراق </span>
          <span>لتقنية المعلومات</span>
        </div>
        <div>
          <span> السجل التجاري </span>
          <span className="font-bold text-gray-800">1010744065</span>
        </div>
      </div>

      <div className="mt-6 flex justify-center gap-2">
        {socialAccounts.map((account) => (
          <a
            key={account.href}
            href={account.href}
            target="_blank"
            rel="noreferrer"
            aria-label={account.label}
            className="inline-flex size-12 items-center justify-center rounded-xl text-gray-700 transition-colors hover:bg-gray-100 hover:text-green-700 focus-visible:ring-2 focus-visible:ring-green-600 focus-visible:ring-offset-2 focus-visible:outline-none"
          >
            <HugeiconsIcon icon={account.icon} size={24} strokeWidth={1.8} />
          </a>
        ))}
      </div>
    </div>
  );
}
